// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e4b7742c","453":"dcd57dc9","732":"ebc49d76"}[chunkId] + ".chunk.js";
};